var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisualization = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 164,
    viewBox: "0 0 266 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.764 88.3458C144.996 88.3458 151.67 81.6878 151.67 73.4747C151.67 65.2616 144.996 58.6035 136.764 58.6035C128.531 58.6035 121.857 65.2616 121.857 73.4747C121.857 81.6878 128.531 88.3458 136.764 88.3458Z",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.606 68.8338C122.128 68.6924 121.626 68.6158 121.095 68.6158C118.173 68.6158 115.812 70.9835 115.812 73.8988C115.812 76.8141 118.173 79.17 121.095 79.17C121.715 79.17 122.317 79.0639 122.866 78.8578",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.416 76.2314C152.036 76.4846 152.709 76.626 153.418 76.626C156.34 76.626 158.713 74.2583 158.713 71.343C158.713 68.4277 156.34 66.0601 153.418 66.0601C152.219 66.0601 151.121 66.4547 150.23 67.1261",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.091 85.6487H156.345C157.626 85.6487 158.647 84.5709 158.571 83.2929L158.075 75.0298L154.928 76.62L152.083 76.4433C152.083 76.4433 150.713 81.7733 146.091 85.6428V85.6487Z",
    fill: "#CB26DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.284 87.38L120.157 88.1397C118.775 88.2575 117.547 87.2504 117.388 85.8781L116.455 77.7917L119.726 79.1169L122.548 78.7046C122.548 78.7046 124.36 83.8992 129.284 87.38Z",
    fill: "#CB26DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.444 66.4482C157.444 66.4482 154.84 46.3825 134.508 48.0551C115.027 49.6571 116.456 70.5827 116.456 70.5827C116.456 70.5827 119.419 67.4023 122.276 69.9761C122.276 69.9761 123.268 63.0087 131.433 59.8696C139.597 56.7304 141.61 58.6033 146.091 61.872C150.076 64.7815 149.438 67.6144 149.438 67.6144C149.438 67.6144 152.089 64.5518 157.444 66.4423V66.4482Z",
    fill: "#CB26DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.321 59.6284C131.321 59.6284 139.113 67.0198 150.235 68.6218C150.235 68.6218 147.88 53.9744 131.321 59.6284Z",
    fill: "#CB26DD",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.095 68.6218C121.095 68.6218 131.149 67.0847 138.794 58.8687C138.794 58.8687 125.847 51.8189 121.095 68.6218Z",
    fill: "#CB26DD",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.695 69.2228C135.695 69.2228 133.145 70.8601 129.284 72.3089L132.49 74.5823",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.199 75.6953C145.199 75.6953 140.777 84.035 131.946 80.3363",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.082 165.876C191.92 172.166 179.092 176.748 164.611 178.209C147.16 179.964 131.161 176.789 120.541 170.435C130.417 162.707 146.375 157.695 164.38 157.695C178.531 157.695 191.418 160.793 201.082 165.876Z",
    fill: "#CB26DD",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.083 165.876C191.419 160.793 178.531 157.696 164.381 157.696C146.375 157.696 130.418 162.708 120.541 170.435C113.002 165.923 108.167 159.81 107.453 152.719C105.729 135.639 128.517 119.36 158.359 116.357C188.201 113.353 213.787 124.767 215.517 141.847C216.402 150.634 210.8 159.215 201.083 165.876Z",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M234.125 42.6431C234.184 42.9906 239.585 70.9248 241.457 80.6072C243.801 92.7457 242.584 96.568 238.659 100.049C233.115 104.961 217.264 103.718 206.791 100.555C174.588 90.8316 150.094 89.4828 119.077 105.332C104.908 112.57 95.0732 122.5 87.1329 130.398C75.8041 141.67 71.1993 145.475 64.0384 143.914C55.7971 142.124 48.3114 121.946 46.074 108.059L25.146 114.855C25.146 114.855 26.3385 122.841 30.8016 134.438C37.6497 152.219 47.2724 162.572 59.3923 165.205C62.1197 165.8 64.7055 166.071 67.1613 166.071C82.2153 166.071 92.5347 155.799 102.565 145.828C110.163 138.266 117.908 130.233 129.172 124.661C151.458 113.63 174.912 113.294 200.469 121.416C212.234 125.156 236.651 128.513 252.018 118.931C260.838 113.436 265.006 104.878 265 96.2087C264.982 76.408 256.05 43.4617 256.033 42.649H234.125V42.6431Z",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0737 108.047V108.061",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6197 107.434C45.6197 107.434 46.4875 92.7162 45.8204 89.7891C44.8168 85.3955 43.6125 83.234 41.2334 83.5638C37.8624 84.0291 38.0927 87.4392 38.0927 87.4392C38.0927 87.4392 37.6204 83.1516 33.6237 83.7405C30.2941 84.2294 30.9553 88.193 30.9553 88.193C30.9553 88.193 30.9022 84.5945 26.752 85.3719C22.6018 86.1494 23.4579 89.954 23.4579 89.954C23.4579 89.954 22.0056 86.0905 19.1719 86.9857C16.3382 87.8809 15.2461 89.9658 16.5803 95.6316C18.0975 102.069 23.5464 114.213 23.5464 114.213L45.6197 107.434Z",
    fill: "#CB26DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M233.044 42.4428C233.044 42.4428 230.14 17.5299 230.358 4.74361C230.429 0.597354 232.956 -1.64657 235.069 1.43367C236.663 3.75416 238.476 18.0482 238.476 18.0482C238.476 18.0482 238.281 12.3765 242.26 12.4531C246.239 12.5296 246.115 18.1365 246.115 18.1365C246.115 18.1365 247.933 13.4307 250.95 14.3318C253.966 15.2329 253.813 20.0624 253.813 20.0624C253.813 20.0624 255.419 16.3637 258.583 17.8302C261.747 19.2967 260.212 24.2028 259.527 27.1417C258.854 30.0452 256.416 41.3591 256.416 41.3591L233.05 42.4369L233.044 42.4428Z",
    fill: "#CB26DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4613 94.5359C75.6677 96.397 70.5906 96.2734 66.1394 94.5654C62.0483 92.9929 58.4825 90.0775 56.1624 86.1256C55.6311 85.2304 55.1647 84.2704 54.7751 83.2692C54.3324 82.1325 54.0018 80.984 53.7774 79.8356C51.9887 70.6243 56.9889 61.1715 66.0626 57.6495C76.2698 53.68 87.7758 58.7273 91.7489 68.9163C92.5045 70.854 92.9355 72.8446 93.0594 74.8118C93.6085 83.1985 88.7204 91.3261 80.4554 94.5418L80.4613 94.5359Z",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.976 88.1698C74.7822 89.4125 71.3936 89.3065 68.4478 88.1286C65.2245 86.8446 62.5206 84.2768 61.1569 80.796C58.5535 74.129 61.8653 66.6139 68.5481 64.0166C75.2368 61.4193 82.7638 64.7234 85.3673 71.3904C85.6211 72.0382 85.8159 72.6861 85.9576 73.3457C87.2977 79.4709 84.0094 85.8257 77.9701 88.1757L77.976 88.1698Z",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36397 104.254L1.79133 102.793C1.53158 102.133 1.93892 101.356 2.68867 101.061L52.5793 81.6847C53.3291 81.3902 54.1555 81.6965 54.4153 82.3561L54.9879 83.8168C55.2477 84.4764 54.8404 85.2538 54.0906 85.5483L4.19997 104.919C3.45022 105.214 2.62373 104.907 2.36397 104.248V104.254Z",
    fill: "#CB26DD",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5328 118.619C67.5328 114.949 64.8881 112.317 61.2161 112.317C64.894 112.317 67.5328 109.678 67.5328 106.015C67.5328 109.684 70.1776 112.317 73.8496 112.317C70.1717 112.317 67.5328 114.955 67.5328 118.619Z",
    fill: "#CB26DD",
    stroke: "#CB26DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1455 65.6795C26.6225 65.6795 27.8198 64.485 27.8198 63.0115C27.8198 61.538 26.6225 60.3435 25.1455 60.3435C23.6685 60.3435 22.4712 61.538 22.4712 63.0115C22.4712 64.485 23.6685 65.6795 25.1455 65.6795Z",
    fill: "#CB26DD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M191.598 53.292C193.075 53.292 194.272 52.0975 194.272 50.624C194.272 49.1505 193.075 47.9561 191.598 47.9561C190.121 47.9561 188.923 49.1505 188.923 50.624C188.923 52.0975 190.121 53.292 191.598 53.292Z",
    fill: "#CB26DD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.798 145.828C238.275 145.828 239.473 144.633 239.473 143.16C239.473 141.686 238.275 140.492 236.798 140.492C235.321 140.492 234.124 141.686 234.124 143.16C234.124 144.633 235.321 145.828 236.798 145.828Z",
    fill: "#CB26DD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisualization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visualization.9397a14ab86ecbcae12d0508c0fa0103.svg";